import { MatStepper } from "@angular/material/stepper";
import { STORAGE_KEY_ID_PERFIL } from "./../../storageCore/constStorageKeys";
import { ToolsService } from "./../../services/migrate/tools.service";
import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import * as FileSaver from "file-saver";
import storageX from "../../storageCore/storageX";
import { Page } from "../../utils/paginate";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatAutocomplete } from "@angular/material/autocomplete";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CoreService } from "../../services/migrate/api.core.service";
import ApiService from "../../services/api.service";
import { Empresa } from "../../models/markerModel";
import { Params } from "../../services/migrate/params";
import { USER_DATA } from "../../utils/constants.util";
import { PermissionsService } from "../../helpers/permissions.service";
import { MatDialog } from "@angular/material/dialog";
import { DriverReportMapComponent } from "../driver-report/driver-report-map.component";

@Component({
  selector: "app-stop-report",
  templateUrl: "./stop-report.component.html",
  styleUrls: ["./stop-report.component.scss"],
})
export class StopReportComponent implements OnInit, AfterViewInit {
  public controlEmpresa = new FormControl();
  public controlVeiculo = new FormControl();
  public controlMotorista = new FormControl();

  public colsHeader = new Array<any>();
  public companys = new Array<any>();
  public companysFiltered = new Observable<Array<any>>();
  public vehicles = new Array<any>();
  public vehiclesFiltered = new Observable<Array<any>>();
  public drivers = new Array<any>();
  public driversFiltered = new Observable<Array<any>>();

  private profileId = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();
  public paramsLoad = {
    profileId: this.profileId,
    size: 9999,
    page: 0,
    sort: "nome",
    sortDirection: "ASC",
  };

  public consultaFormGroup: FormGroup;
  permissions: [];

  public serviceCore: CoreService;
  public serviceApi: ApiService;

  public pagination = new Page();
  public matStepper: MatStepper;
  public matAutocomplete: MatAutocomplete;
  public filterDialog = true;
  public items;

  public resultado = new Array<any>();
  public resultadoAnalitico = new Array<any>();
  public resultadoTotal = new Array<any>();

  public enumTipoVelocidade: string = "";
  public opcoesOdometro: { value: number; label: string }[] = [];

  public empresaFilterSelected;
  public companiesFilter: any = [];

  public companiesSelect: any = [];

  constructor(
    private tools: ToolsService,
    apiserviceCore: CoreService,
    serviceApi: ApiService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public permissionService: PermissionsService,
  ) {
    this.serviceCore = apiserviceCore;
    this.serviceApi = serviceApi;
  }

  ngAfterViewInit(): void {
    this.filterDialog = true;
  }

  ngOnInit() {
    this.permissions = this.permissionService.getPermissions();
    this.pagination.currentPage = 0;
    this.pagination.size = 10;

    this.tools.builder().spinner.show();
    this.loadDataElements();

    this.consultaFormGroup = this.formBuilder.group({
      selecaoEmpresa: [""],
      searchAddress: [false],
      dataInicio: ["", Validators.required],
      dataFim: ["", Validators.required],
      tipoRelatorio: ["", Validators.required],
      tipoOdometro: ["", Validators.required],
    });

    this.companysFiltered = this.controlEmpresa.valueChanges.pipe(
      // Passa o valor bruto (string durante digitação, objeto quando selecionado)
      map((value) => value),
      map((value) =>
        value ? this.filterValuesEmpresa(value) : (this.companiesFilter?.length ? this.companiesFilter.slice() : this.companys.slice())
      )
    );

    this.vehiclesFiltered = this.controlVeiculo.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.cdPlaca)),
      map((name) =>
        name ? this.filterValuesTerminal(name) : this.vehicles.slice()
      )
    );

    this.driversFiltered = this.controlMotorista.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.nmNome)),
      map((name) =>
        name ? this.filterValuesMotorista(name) : this.drivers.slice()
      )
    );
  }

  public filterValuesEmpresa(value: any): Array<any> {
    // Seleção (objeto) -> carrega dados e mantém opções atuais
    if (value && typeof value === 'object' && value.id) {
      const selecionada = value;
      if (selecionada.cnpj != null) {
        this.loadFilterCompany(selecionada.id);
      } else {
        this.loadFilterDivision(selecionada.id);
      }
      return this.companiesFilter?.slice() || [];
    }

    // Digitação (string/number) -> filtra localmente
    const texto = (value ?? '').toString().toLowerCase();
    const base = this.companiesFilter?.length ? this.companiesFilter : this.companys;
    return base
      .slice()
      .sort((a, b) => a.nmNome.localeCompare(b.nmNome))
      .filter((client) => (client?.nmNome || '').toLowerCase().includes(texto));
  }

  displayEmpresa(empresa: Empresa): string {
    return empresa && empresa.nmNome ? empresa.nmNome : "";
  }


  public filterValuesTerminal(value: string): Array<any> {
    const filterValue = value.toLowerCase();
    return this.vehicles
      .sort((a, b) => a.cdPlaca.localeCompare(b.cdPlaca))
      .filter((client) => client.cdPlaca.toLowerCase().includes(filterValue));
  }

  displayTerminal(terminal: any): string {
    console.log(terminal);

    let terminalPlaca = terminal.cdPlaca ? terminal.cdPlaca : "";
    let terminalFrota = terminal.frota ? terminal.frota : "";

    return terminal.cdPlaca ? `${terminalPlaca}/${terminalFrota}` : "";
  }

  // Método chamado ao selecionar um veículo
  selecionarVeiculo(terminal: any): void {
    if (!terminal) return;

    console.log("Veículo selecionado:", terminal);

    // Define o tipo de velocidade do terminal selecionado
    this.enumTipoVelocidade = terminal.enumTipoVelocidade?.toString() || "0";

    // Atualiza as opções do dropdown
    this.carregarOpcoesOdometro();
  }

  // Método para carregar as opções do dropdown corretamente
  private carregarOpcoesOdometro(): void {
    if (this.enumTipoVelocidade === "0") {
      console.log("Exibindo GPS e CAN");
      this.opcoesOdometro = [
        { value: 1, label: "GPS" },
        { value: 2, label: "CAN" }
      ];
    } else {
      console.log("Exibindo apenas CAN");
      this.opcoesOdometro = [{ value: 1, label: "GPS" }];
    }
  }

  public filterValuesMotorista(value: string): Array<any> {
    console.log("filterValuesMotorista");
    const filterValue = value.toLowerCase();
    return this.drivers
      .sort((a, b) => a.nmNome.localeCompare(b.nmNome))
      .filter((client) => client.nmNome.toLowerCase().includes(filterValue));
  }

  displayMotorista(motorista: any): string {
    return motorista && motorista.nmNome ? motorista.nmNome : "";
  }

  public paginate(event) {
    const params = this.tools.builder().params;

    this.pagination.currentPage = event.page;
    this.pagination.size = event.rows;
  }

  public onOpenDialogFilter() {
    this.filterDialog = true;
  }

  private getGoogleMapsUrl(lat: number | string, lng: number | string): string {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  }

  private createPdfEnderecoHooks(
    doc: any,
    rows: any[],
    enderecoColIndex: number
  ) {
    return {
      didParseCell: (data: any) => {
        if (data.section !== "body" || data.column.index !== enderecoColIndex) {
          return;
        }
        const row = rows[data.row.index];
        if (!row || row.latitude == null || row.longitude == null) {
          return;
        }
        const label =
          row.endereco && String(row.endereco).trim()
            ? String(row.endereco).trim()
            : "Ver no Google Maps";
        data.cell.text = label;
        data.cell.styles = {
          ...data.cell.styles,
          textColor: [0, 0, 255],
          fontStyle: "underline",
        };
      },
      didDrawCell: (data: any) => {
        if (data.section !== "body" || data.column.index !== enderecoColIndex) {
          return;
        }
        const row = rows[data.row.index];
        if (!row || row.latitude == null || row.longitude == null) {
          return;
        }
        doc.link(data.cell.x, data.cell.y, data.cell.width, data.cell.height, {
          url: this.getGoogleMapsUrl(row.latitude, row.longitude),
        });
      },
    };
  }

  exportPdf() {
    // Função para carregar a imagem e converter para base64
    const loadImageAsBase64 = (url) => {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
      });
    };

    // Função para adicionar o cabeçalho ao PDF
    const addHeader = (doc, imgData, data) => {
      const pageWidth = doc.internal.pageSize.width;

      // Dimensões da imagem
      const imgWidth = 40;
      const imgHeight = 40;

      const marginLeft = 200;
      const marginTop = 10;

      // Adicionando a imagem
      doc.addImage(imgData, "PNG", marginLeft, marginTop, imgWidth, imgHeight);

      var text = "";

      // Texto do cabeçalho
      if (this.resultado.length > 0) {
        text = "SETERA - RELATÓRIO SINTÉTICO POSIÇÕES";
      }

      if (this.resultadoAnalitico.length > 0) {
        text = "SETERA - RELATÓRIO ANALÍTICO POSIÇÕES";
      }

      const textX = marginLeft + imgWidth + 10;
      const textY = marginTop + imgHeight / 2 + 5;

      doc.setFontSize(18);
      doc.setTextColor("#0000FF");
      doc.setFont("helvetica", "bold");
      doc.text(text, textX, textY);
    };

    if (this.resultado.length > 0) {
      import("jspdf").then((jsPDF) => {
        import("jspdf-autotable").then(() => {
          const doc = new jsPDF.default("l", "pt");

          loadImageAsBase64("assets/img/logo-aba.png")
            .then((imgData) => {
              // Callback para adicionar o cabeçalho em cada página
              const header = (data) => {
                addHeader(doc, imgData, data);
              };

              const enderecoHooks = this.createPdfEnderecoHooks(
                doc,
                this.resultado,
                6
              );

              doc.autoTable({
                startY: 60,
                html: ".table",
                useCss: true,
                didDrawPage: header,
                margin: { top: 60 },
                ...enderecoHooks,
              });

              // Adiciona o cabeçalho à primeira página
              addHeader(doc, imgData, { settings: { margin: { left: 40 } } });

              doc.save(`relatorio_posicoes.pdf`);
            })
            .catch((error) => {
              console.error("Erro ao carregar a imagem:", error);
            });
        });
      });
    } else if (this.resultadoAnalitico.length > 0) {
      import("jspdf").then((jsPDF) => {
        import("jspdf-autotable").then(() => {
          const doc = new jsPDF.default("l", "pt");

          loadImageAsBase64("assets/img/logo-aba.png")
            .then((imgData) => {
              const header = (data) => {
                addHeader(doc, imgData, data);
              };

              const enderecoHooks = this.createPdfEnderecoHooks(
                doc,
                this.resultadoAnalitico,
                12
              );

              doc.autoTable({
                startY: 60,
                html: ".tableAnalitico",
                useCss: true,
                didDrawPage: header,
                margin: { top: 60 },
                ...enderecoHooks,
              });

              addHeader(doc, imgData, { settings: { margin: { left: 40 } } });

              doc.save(`relatorio_posicoes.pdf`);
            })
            .catch((error) => {
              console.error("Erro ao carregar a imagem:", error);
            });
        });
      });
    }
  }

  exportExcel() {
    if (this.resultado.length > 0) {
      import("xlsx").then((xlsx) => {
        const worksheet = xlsx.utils.table_to_sheet(
          document.getElementsByClassName("table")[0],
          { dateNF: "mm/dd/yyyy hh:mm:ss", cellDates: true }
        );
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        this.saveAsExcelFile(excelBuffer, `relatorio_posicoes`);
      });
    } else if (this.resultadoAnalitico.length > 0) {
      import("xlsx").then((xlsx) => {
        const worksheet = xlsx.utils.table_to_sheet(
          document.getElementsByClassName("tableAnalitico")[0],
          { dateNF: "mm/dd/yyyy hh:mm:ss", cellDates: true }
        );
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        this.saveAsExcelFile(excelBuffer, `relatorio_posicoes`);
      });
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      `relatorio_posicoes` + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  public openMap(lat, long) {
    console.log("openMap");
    const dialogRef = this.dialog.open(DriverReportMapComponent, {
      width: "450px",
      height: "450px",
      data: {
        lat: lat,
        lng: long,
      },
    });
  }

  public onConsultar() {
    if (
      this.consultaFormGroup.valid &&
      this.controlVeiculo.value != null &&
      this.controlVeiculo.value != ""
    ) {
      const params = new Params();

      const dataInicioRaw = this.consultaFormGroup.value.dataInicio;
      const dataFimRaw = this.consultaFormGroup.value.dataFim;

      // Converte para Date
      const dataInicio = new Date(dataInicioRaw);
      const dataFim = new Date(dataFimRaw);

      // Função auxiliar para garantir formatação completa
      const formatDateTime = (d: Date): string => {
        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      };

      const startDate = formatDateTime(dataInicio);
      const endDate = formatDateTime(dataFim);

      params.setParam("tipoOdometro", this.consultaFormGroup.value.tipoOdometro);

      if (
        this.controlEmpresa.value != null &&
        this.controlEmpresa.value != ""
      ) {
        params.setParam("idEmpresa", this.controlEmpresa.value.id);
      }
      if (
        this.controlMotorista.value != null &&
        this.controlMotorista.value != ""
      ) {
        params.setParam("idMotorista", this.controlMotorista.value.id);
      }
      if (
        this.controlVeiculo.value != null &&
        this.controlVeiculo.value != ""
      ) {
        params.setParam("idTerminal", this.controlVeiculo.value.id);
      }
      params.setParam("livreValor", this.consultaFormGroup.value.tipoRelatorio);
      params.setParam("startDate", startDate);
      params.setParam("endDate", endDate);

      params.setParam("saltoGps", this.consultaFormGroup.value.searchAddress);

      this.tools.builder().spinner.show();
      this.tools
        .builder()
        .api.get(
          `${this.tools.builder().api.getApiUrl().reports}/relatorio-posicoes`,
          params.build()
        )
        .subscribe((r: any) => {
          if (this.consultaFormGroup.value.tipoRelatorio == 1) {
            this.resultado = r;
            this.resultadoTotal = [this.resultado[0]];
            this.resultadoAnalitico = new Array<any>();
          } else if (this.consultaFormGroup.value.tipoRelatorio == 2) {
            this.resultadoAnalitico = r;
            this.resultado = new Array<any>();
            this.resultadoTotal = new Array<any>();
          }
          this.pagination = r.pagination;
          this.tools.builder().spinner.hide();
          this.filterDialog = false;
          if (this.consultaFormGroup.value.tipoRelatorio == 1) {
            if (this.resultado.length == 0) {
              this.tools
                .builder()
                .openToast.emitInf("Nenhum resultado para exibir no momento.");
            }
          } else if (this.consultaFormGroup.value.tipoRelatorio == 2) {
            if (this.resultadoAnalitico.length == 0) {
              this.tools
                .builder()
                .openToast.emitInf("Nenhum resultado para exibir no momento.");
            }
          }
        });
    }
  }

  public async loadDataElements() {
    try {
      this.tools.builder().spinner.show();

      const companys = await this.serviceCore.get<any>({
        url: "v2/companys",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.companys = companys?.elements;
      // Inicializa a lista utilizada pelo autocomplete de empresas
      this.companiesFilter = this.companys?.slice() || [];
      this.companys = this.companys.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );
      this.controlEmpresa.setValue("");

      const terminals = await this.serviceCore.get<any>({
        url: "v2/terminals",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sortDirections: "ASC",
        },
      });

      this.vehicles = terminals.elements;
      // Filtra veículos com cdPlaca nulo ou vazio
      this.vehicles = this.vehicles.filter(vehicle => vehicle.cdPlaca && vehicle.cdPlaca.trim() !== '');
      this.vehicles = this.vehicles.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );
      this.controlVeiculo.setValue("");

      const drivers = await this.serviceCore.get<any>({
        url: "v2/drivers/getAll",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.drivers = drivers.elements;
      this.drivers = this.drivers.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );

      this.controlMotorista.setValue("");

      this.companiesSelect = [
        { name: "Divisão", value: 1 },
        { name: "Matriz", value: 2 },
        { name: "Filial", value: 3 },
      ];

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadFilterCompany(value: any) {
    try {
      this.tools.builder().spinner.show();

      const terminals = await this.serviceCore.get<any>({
        url: "v2/terminals/findByCompany",
        params: {
          profileId: USER_DATA().profileId,
          idEmpresa: value,
          size: "5000",
          page: "0",
          sortDirections: "ASC",
        },
      });

      this.vehicles = terminals.elements;
      // Filtra veículos com cdPlaca nulo ou vazio
      this.vehicles = this.vehicles.filter(vehicle => vehicle.cdPlaca && vehicle.cdPlaca.trim() !== '');
      this.vehicles = this.vehicles.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );

      this.controlVeiculo.setValue("");

      const drivers = await this.serviceCore.get<any>({
        url: "v2/drivers/findByCompany",
        params: {
          profileId: USER_DATA().profileId,
          idEmpresa: value,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.drivers = drivers.elements;
      this.drivers = this.drivers.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );

      this.controlMotorista.setValue("");

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadFilterDivision(value: any) {
    try {
      this.tools.builder().spinner.show();

      const terminals = await this.serviceCore.get<any>({
        url: "v2/terminals/findByDivision",
        params: {
          profileId: USER_DATA().profileId,
          idDivisao: value,
          size: "5000",
          page: "0",
          sortDirections: "ASC",
        },
      });

      console.log(terminals);

      this.vehicles = terminals.elements;
      // Filtra veículos com cdPlaca nulo ou vazio
      this.vehicles = this.vehicles.filter(vehicle => vehicle.cdPlaca && vehicle.cdPlaca.trim() !== '');
      this.vehicles = this.vehicles.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );

      this.controlVeiculo.setValue("");

      const drivers = await this.serviceCore.get<any>({
        url: "v2/drivers/findByDivision",
        params: {
          profileId: USER_DATA().profileId,
          idDivisao: value,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      console.log(drivers);

      this.drivers = drivers.elements;
      this.drivers = this.drivers.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );

      this.controlMotorista.setValue("");

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async filterCompanyReports() {
    this.controlEmpresa.setValue("");
    var idEmpresa = this.empresaFilterSelected;
    var empresas:any = [];

    console.log(this.companysFiltered);

    if (idEmpresa == "Divisão") {
      this.companys.forEach((element) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Matriz") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Filial") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;

    this.companysFiltered.subscribe(this.companiesFilter);
  }
}
